import { render } from "./PlaceDetails.vue?vue&type=template&id=03dc8230&scoped=true"
import script from "./PlaceDetails.vue?vue&type=script&lang=js"
export * from "./PlaceDetails.vue?vue&type=script&lang=js"

import "./PlaceDetails.vue?vue&type=style&index=0&id=03dc8230&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03dc8230"]])

export default __exports__